<template>
  <div class="container-fluid" id="occupation">
    <Navigation></Navigation>
    <div class="row wrapper">
      <div class="col-12 col-md-4 side-banner">
        <div class="header">
          <!-- <div id="steps" class="steps" tabindex="0" role="document">
						<span>Step {{ step }} of {{ steps }} (continued)</span>
					</div> -->
          <div class="company-logo"></div>
          <h1 tabindex="0" class="occupation-classification-title">{{pageContent.occupationClassificationTerm}}</h1>
          <div class="hero-image" alt="Your insurance needs"></div>
        </div>
      </div>
      <div class="col-12 col-md-8 main-banner">
        <div class="main">
          <h1 tabindex="0">Determine your {{pageContent.occupationClassificationTerm}}</h1>

          <p v-html="pageContent.pages.occupation.customIntroText"></p>

          <p tabindex="0">
            You must choose the {{pageContent.occupationClassificationTerm}} that best reflects
            your usual type of work. If it is found that your {{pageContent.occupationClassificationTerm}} has been misstated, the Insurer may adjust your
            insurance cover and {{pageContent.costTerm}} based on the correct {{pageContent.occupationClassificationTerm}}.
          </p>

          <div class="row row-cols-1">
            <b-card
              class="col choice-box p-0"
              :class="{ 'mb-2': (i+1) < occupations.length }"
              role="button"
              v-for="(o, i) in occupations" :key="i"
              @click="occupationAndContinue(o.name)"
              tabindex="0"
              @keyup.enter="occupationAndContinue(o.name)"
            >
              <div class="row align-items-center">
                <div class="col-2" style="text-align: center">
                  <i :class="'icon job-'+o.type"></i>
                </div>
                <div class="col">
                  <h3>{{ o.name }}</h3>
                  <div v-html="o.html"></div>
                  <small>
                    <ul>
                      <li v-for="(d, di) in o.desc" :key="di">
                        {{ d }}
                      </li>
                    </ul>
                    {{ o.examples }}
                  </small>
                </div>
                <div class="col-1 pl-0">
                  <div
                    class="next-click"
                    @click="occupationAndContinue(o.name)"
                  ></div>
                </div>
              </div>
            </b-card>
          </div>

          <p v-if="pageContent.contactNumber.text" tabindex="0" class="mt-4">
            <b>Unsure which option to choose?</b><br />
            If you’re unsure which option to choose, call us on
            <a :href="'tel:'+pageContent.contactNumber.value">{{ pageContent.contactNumber.text }}</a>.
          </p>

          <div class="nav-button row">
            <router-link
              class="assumption-button col"
              :to="{ name: 'Disclaimer', params: { activeTab: 'disclaimer' } }"
              tabindex="0"
              role="button"
              ><i class="icon-info disclaimer"></i>Disclaimer</router-link
            >
            <router-link
              class="back-button col"
              to="/next-options"
              tabindex="0"
              role="button"
              >Back
            </router-link>
            <!--<button class="next-button col" v-bind:class="[valid ? 'is-active' : 'is-disabled']"  type="submit" tabindex="0" role="button">Next</button>-->
          </div>
        </div>
      </div>
    </div>
    <CustomFooter></CustomFooter>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import CustomFooter from "../components/CustomFooter";
import Navigation from "../components/Navigation.vue";

extend("required", {
  ...required,
  params: ["msg"],
  message: "{msg}",
});

export default {
  name: "Occupation",
  components: { CustomFooter, Navigation },
  computed: {
    ...mapFields(["data", "acceptedDisclaimer", "skipCalculations", "prevTab"]),
    ...mapGetters(["Enum", "occupations", "pageContent"]),
    step() {
      return this.skipCalculations ? 1 : 6;
    },
    steps() {
      return this.skipCalculations ? 2 : 7;
    },
  },
  methods: {
    clickDisclaimer(e) {
      this.$store.commit("updateAcceptedDisclaimer", e.target.checked);
      this.triggerHeightCheck();
    },
    triggerHeightCheck: function () {
      // Add slight delay otherwise incorrect height is read
      var rf = this;
      setTimeout(function () {
        rf.$refreshIframeHeight();
      }, 300);
    },
    occupationAndContinue(occupation) {
      this.data.stepData.occupation = occupation;
      this.$router.push("/cover-cost");
      this.triggerHeightCheck();
    },
  },
  mounted() {
    this.$refreshIframeHeight();
    this.$scrollIframeTop();
    window.addEventListener("resize", this.$refreshIframeHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.$refreshIframeHeight);
  },
  beforeDestroy() {
    // send analytics - complete form step
    this.$gtag.event("step-occupation", {
      event_category: "form-step-progress",
      event_label: JSON.stringify({
        occupation: this.data.stepData.occupation,
      }),
    });
  },
};
</script>
